var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-6"},[_c('client-form',{attrs:{"client":_vm.client,"title":"Editar cliente"},on:{"submit":_vm.updateClient}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }